export const dwoVac = [
  {
    title: "District Wellness Officer or DWO :- Vacancy - 4153 posts",
    qualifications:
      "Any graduate or equivalent And/ Or Intermediate in Science",
    preference:
      "Graduate with intermediate in science or 2 year and above working Experience in Healthcare Industry or Pharmaceutical Industry/Insurance as executive",
    serviceType:
      "Full-time (Home-Base Field job with Office Reporting when asked) Time - 10 am to 6:30 pm",
    salary:
      "Senior DWO: Starting from Rs. 25,000/- per month (Will be categorised based on online interview results, qualifications, suitability of experience for the position, and performance during training.)",
    salary2:
      "Junior DWO: Starting from Rs. 20,000/- per month (Will be categorised based on online interview results, qualifications, suitability of experience for the position, and performance during training.)",
    promotion:
      "Applicable with 5% to 20% increment per year or candidate/s will be shifted to Career Progression Programme with no retirement. (T & C Apply)",
    pensionScheme:
      "Available up to 75 years of Age, Retirement – at the age of 65 years. (T & C Apply)",
    mediclaimFacility: "Available for Self and Spouse. (T & C Apply)",
    groupTermInsurance: "Rs. 15,00,000/- (T & C Apply)",
    ageLimit: "22 to 45 years as on 01/01/2026",
    language:
      "Candidate must have the ability to speak (Read and Write also) fluently in the regional or local language of the region for which he/she opted in the Application Form (consider one state as one region). Mandatory – English (read, write & speak); Optional – Hindi (speaks)",
    jobResponsibility:
      "Senior and Junior DWOs are responsible for implementing Healthcare & Wellness Awareness, Assessment, and Counselling Programmes at the district level. The Senior DWO acts as a coordinator, working closely with Junior DWOs in a collaborative, non-hierarchical manner.",
    jobResponsibility1: null,
    keyResponsibility: [
      "Senior DWO leads presentations and field activities; Junior DWO assists with appointment setting, assessments, and on-ground coordination.",
      "Both DWOs support health checkups and maintain accurate records.",
      "DWOs do not deliver food/supplements directly but communicate health seeker orders to 2nd party vendor distributors, with support from the RWO.",
      "Junior DWO reports daily to the Senior DWO and updates all transactions and records in the system. The Senior DWO oversees daily progress and reporting.",
      "Monitor daily activities and performance of district-level teams.",
      "Assist healthcare entrepreneurs associated with the mission in the district.",
      "Promote teamwork, mentorship, and shared responsibility. Both roles include continuous self-development and leadership growth.",
      "Promote the membership and its benefits across India, while ensuring a smooth subscription process.",
      "Additional official and mission-specific tasks may be assigned by the RWO or Mission Director.",
    ],

    reporting: "Reporting to concerned RWO OR Zonal Head OR Mission Director",
  },
];

  export const rwoVac = [
    {
      title: "Regional Wellness Officer or RWO :- No Vacancies Available",
      qualifications:
        "Graduate or equivalent in any science like Community Science, Life science, Veterinary Science, Agri. Science, MBBS, BDS, BE., BTech, Food & Nutrition Science, MBA with 12th pass in Science or MSW with 12th pass in Science",
      preference:
        "Master graduate or equivalent with 12th class in Science\n2 years & above working Experience in Hospital as Medical Officer or Healthcare & Wellness as Senior Executive or Pharmaceutical/Insurance industry as Team Leader",
      serviceType:
        "Full-time (Home-Base Field job with Office Reporting when asked) Time - 10 am to 6:30 pm",
      salary: "Starting from Rs. 50,000/- per month",
      salary2: "",
      promotion:
        "Applicable with 5% to 20% increment per year or candidate/s will be shifted to Career Progression Programme with no retirement. (T & C Apply)",
      pensionScheme:
        "Available up to 75 years of Age, Retirement – at the age of 65 years. (T & C Apply).",
      mediclaimFacility:
        "Available for Self, Spouse and 1 Child. (T & C Apply)",
      groupTermInsurance: "Rs. 25,00,000/- (T & C Apply)",
      ageLimit: "25 to 50 years as on 01/01/2026",
      language:
        "Candidate must have the ability to speak fluently (Read and Write also) in the regional language of the region for which he/she opted in the Application Form (consider one or more than one state as one region). Mandatory – English (speak, read & write) Hindi (speak & read)",
      keyResponsibility: null,
      jobResponsibility: null,
      jobResponsibility1: [
        "Manage and coordinate the activities of Senior and Junior DWOs across the region.",
        "Plan and implement leadership development programmes for DWOs.",
        "Oversee regional execution of Healthcare & Wellness Awareness, Assessment, and Counselling Programmes.",
        "Monitor daily activities and performance of district-level teams.",
        "Allocate healthcare tools, food, and supplements to DWOs, and maintain accurate records.",
        "Ensure that food, supplements, and healthcare tools are delivered by designated distributors of 2nd-party vendors—not by DWOs directly.",
        "DWOs will facilitate the supply process by collecting orders from health seekers and forwarding them to the concerned vendors/distributors.",
        "Coordinate with vendors/distributors to ensure timely and efficient delivery of commodities.",
        "Help your team promote the membership and its benefits across India, and guide people through an easy subscription process.",
        "Liaise with the Mission Director for strategic direction, reporting, and official communication.",
        "Perform any additional responsibilities as assigned by the Mission Director.",
      ],
      reporting: "Zonal Head OR Mission Director",
    },
  ];

export const ProceduresNew = [
  {
    value: "procedure",
    title: "Selection Procedure",
    descriptionList: [
      " Applicants are required to submit an online application for the interview registration",
      " Interview-qualified candidates must enroll in a certificate course titled “Certificate in Principles of Applied Nutrition and Wellness” under the National School of Nutrition (NSN).",
      " No candidate will be eliminated after the successful completion of the certificate course and appointed as per the final course certificate achieved. ",
    ],
  },
  {
    value: "fees",
    title: "Processing Fees",
    descriptionList: [
      " Interview registration is absolutely FREE.",
      " Interview-qualified candidates are required to pay the applicable course fee for the above-mentioned certificate course. The course fee usually ranges from INR 5k to 15K for NHWM's interview-qualified Candidates.",
    ],
  },
  {
    value: "rules",
    title: "Rules, Terms & Conditions",
    descriptionList: [
      "Government or private employees, whether temporary or permanent, are eligible to appear for the interview, provided they possess the requisite qualifications and are within the prescribed age limit. They may submit an experience certificate from their employer.",
      "Completion of interview registration implies that the candidate has understood the entire selection process mentioned on the Career Page - (https://nhwm.in/career).",
      "Any fee paid by candidates towards interview or certificate course enrollment shall be non-refundable under any circumstances.",
      "A candidate must be of good mental condition and bodily healthy and free from any physical defect likely to interfere with the discharge of his duties as an officer of the service. A candidate, who after medical examination as the selection board may prescribe, is not found to satisfy these requirements will not be appointed.",
      "Any attempt on the part of a candidate to obtain support for his or her candidature, by any means whatsoever, may be deemed by the Selection Board as sufficient grounds for disqualification from the online interview at any stage",
      "No person who has more than one spouse living or in case of woman candidate if married to a person having a spouse living shall be eligible for appearing at the online interview. Provided, if satisfied that such marriage is permissible under the personal law applicable to such person, exempt from the operation of this rule.",
      "The decision of the Selection Board regarding the eligibility of a candidate for admission to the online interview, admission to the Certificate Course, or issuance of appointment shall be final. A candidate who has not been selected by the Board shall not be permitted to be admitted to the Certificate Course.",
      "A candidate shall be summarily rejected if he/she fails to comply with the rules, regulations, terms, and conditions of the organization in any respect.",
      "On the basis of the results of the online interview and the qualifications assessed by the Selection Board, a list of successful candidates found suitable for the Certificate Course shall be prepared.",
      "Candidates who qualify in the interview and wish to join the Certificate Course must pay a Course Enrollment Fee, which will be communicated after completion of the interview process.",
      "Selection of a candidate for the Certificate Course shall mean final selection for appointment, provided that he/she successfully completes the course and obtains the course certificate.",
      "If the number of candidate/s in the final selection list of a particular post/s will exceed the number of vacant post/s available in a particular region/location, the appointment will be done on the merit basis up to the fill up of the vacant post/s. Other selected candidate of that particular post and region/location respectively will be relocated nearby or where management of NHWM will find comfortable.",
      "No accommodation, remuneration and traveling cost will be provided by the management of NHWM to the candidate/s invited for viva(Offline/Online), Training(Offline/Online) or Physical Fitness Test.",
      "Candidates shall be considered for appointment to Services/Location subject to availability of vacancies in that Job/Location.",
      "In cases where the preferences given by candidates become unworkable—either due to the number of candidates selecting a particular job/location exceeding the available vacancies or due to insufficient preferences for a given job/location—the Board of Selection of NHWM shall have the right to allocate a candidate to any service or location deemed most suitable, irrespective of their stated preference. In making such an allotment, the Board shall, as far as possible, consider the candidate’s professional qualifications and background.",
      "No candidate, whether selected or not, whether having appeared or not in the interview or Certificate Course, nor any new or existing employee of NHWM, shall approach any third-party organization or individual, whether Government or Non-Government, to raise any dispute against NHWM or its collaborative partner, Optim Health & Wellness (OPC) Pvt. Ltd., unless the management of NHWM and Optim Health & Wellness (OPC) Pvt. Ltd. has formally denied, in writing, the resolution of such dispute internally.",
      "No candidate, whether selected or not, whether having appeared or not in the interview or Certificate Course, nor any new or existing employee of NHWM, shall engage in or be involved in any form of union activity or the formation of any union, either personally or through online social media platforms.",
      "The Interview Selection Board, the management of NHWM, and our collaborative partner, Optim Health & Wellness (OPC) Pvt. Ltd., reserve the right to change, cancel, alter, decrease, or increase the number of posts; revise the salary mentioned in the Job Description according to the grade of the post; and postpone or terminate any matter related to the job notification before, during, or after the interview, selection, or appointment process, at any time, without prior notice to any person inside or outside NHWM.",
    ],
  },
];

export const FAQSNew = () => {
  return [
    {
      question: "Is it a fraud Advertisement?",
      answer: (
        <>
          Absolutely NOT. This is not a fraud. Before releasing this
          advertisement we have completed all the formalities required. The NHWM
          is launched for a very genuine purpose to educate and help people of
          Bharat. We have intimated about our mission to President of India, PM
          of India, CM of every State of India and also intimated to the Office
          of the Director of Health Services of every state. (Candidates are
          Requested to beware of Fraud Job Advertisements).
          <br />
        </>
      ),
    },
    {
      question: "What is NHWM?",
      answer:
        "National Healthcare and Wellness Mission is a mission nationwide in Bharat for educating people how to stay healthy & get prevented or reverse from Lifestyle Diseases (like Heart Disease, Diabetes & many other Degenerative Diseases) and how to save ourselves from heavy healthcare costing that may come unexpectedly in someone’s life. This mission will be associating with awareness presentation in English, Hindi and regional language along with proper expertised health assessment and counselling programme in a very nominal cost.",
    },
    {
      question:
        "Is this advertisement for any central or any state government job?",
      answer:
        "NHWM is a collaborative mission. Though, it is not a government initiative, NHWM provides as much facilities as possible to their employee like a government employee gets. So, we adopt all the employee-friendly policies which are attracting good quality people to work with NHWM. So, people are crazy to join as an employee in NHWM.",
    },
    {
      question: "What are the mission phases of NHWM?",
      answer:
        "NHWM has many phases of working Strategy. The first phase is for 7 years starting from 1st of January 2024 to 31st of December 2030. The other phases will be of 5 years each with proper strategies. Total 5 phases and working strategies have been formulated up to 31st of December 2050.",
    },
    {
      question: "How many job posts are vacant as of now for NHWM?",
      answer:
        "For the time being, 4153 posts of various responsibilities are vacant nationwide, and vacant posts are segregated region-wise (one or more than one states is representing a region).",
    },
    {
      question: "Will any doctors be involved in this mission?",
      answer:
        "Yes, we already have a few qualified doctors associated with this mission. However, we are looking to onboard more qualified doctors. Interested candidates are most welcome to apply for the post of Regional Officer (RWO) through our direct online interview process.",
    },
    {
      question: "Where is the head office of NHWM situated?",
      answer:
        "It is situated in - H. No. 1, Karbi Namghar Path, Khagen Mahanta Road, Hengrabari, Near Karbi Namghar, Borbari, Guwahati, Assam 781036",
    },
    {
      question:
        "Why should I appear in the online interview to get a job in NHWM?",
      answer:
        "This online interview explains how to join NHWM quickly through our fast-track process, instead of the previous lengthy BRT recruitment procedure.",
    },
    {
      question:
        "Do I have to pay any fee for the online interview registration?",
      answer: "No, registration for the online interview is absolutely FREE. ",
    },
    {
      question:
        "I am not a citizen of Bharat. Can I register for this interview?",
      answer: "No, you are not eligible to register for this interview.",
    },
    {
      question:
        "I will be obtaining my Bachelor or Master degree in June of next year (2026). Can I apply?",
      answer:
        "Please check the age limit and the qualification required for each category of vacant posts. If your situation is matching the requirements then you can apply.",
    },
    {
      question:
        "What is a Career Progression Programme mentioned in the Advertisement?",
      answer:
        "It is a lifetime incentive programme. This incentive Programme will be started simultaneously with the salary from the very 1st month of joining of the employee. When this incentive crosses the 200 % of the Salary continuously for 3 – 6 months, the employee will be shifted to this lifetime incentive programme. This programme will help the employee to grow too many folds than normal salary. The dedication level of the employee will be at utmost level because of this programme, and we will be very happy to see our employee happy.",
    },
  ];
};

export const ACCUSATIONS = [
  "Obtaining support for candidature by any means",
  "Impersonation",
  "Procuring impersonation by any person",
  "Submitting fabricated & tampered documents",
  "Making statements which are incorrect or false or suppressing material fact or information",
  "Using unfair means during the examination",
  "Writing irrelevant or obscene or pornographic matter in the script/s or uploaded in the online form",
  "Misbehaving online or offline with the examiner or the invigilator",
  "Harassing or causing bodily harm to the staff employed/engaged by the board",
  "Violating any of the instructions contained in the Exam Admit Card",
  "Attempting to commit or abetting any of the acts specified in the clauses",
  "Violating any of the Terms, Conditions or Rules",
  // Add more accusations as needed
];

export const CONSEQUENCES = [
  "To be disqualified by the Board from the examination",
  "To be suspended, either permanently or for a specified period, from appearing in any examination or selection held by the Board",
  "If already in service under government/private and did not declare in the application form, candidature will be suspended either permanently or for a specific period",
  "To face legal events/actions as decided to sue by the Management of NHWM",
];

export const examRules = [
  "Appearing the exam in MOBILE or TABLET is not allowed. (Exam is incompatible to Mobile or Tablet)",
  "No top-up of time allotted for 2nd Sections of exam if you finish the 1st Section earlier.",
  "Minimizing the main Exam Window will not be allowed during examination.",
  "No video and audio OFF is allowed during Exam.",
  "No other person will be allowed in your examination room.",
  "After submitting the paper, take permission from the Proctor to leave the Zoom.",
  "If a candidate has submitted the paper without connecting in Zoom will not be accepted/evaluated.",
  "Blur background or using a background wall-paper is not allowed in Zoom.",
  "You have to show us your Room, Table and Mobile (where you have kept it) by moving your Laptop or Webcam.",
  "Your video will be recorded. If any suspicious activities are observed during the exam, it may result in disqualification from the final interview round due to a lack of honesty.",
  "A few other rules are mentioned or will be mentioned on your ADMIT CARD that must be followed by each and every candidate.",
];

export const SyllabusNew = () => [
  {
    title: "OUTLINED SYLLABUS FOR BRT (2025-2026)",
    content: [
      "For RWO candidates:- Total 100 Marks",
      "Part 1 – General Knowledge (20 Marks)",
      "• Indian History",
      "• Indian Economy",
      "• Indian Geography",
      "• Indian Politics",
      "",
      "Part 2 – Special Paper (80 Marks)",
      "• Basics of Human Anatomy",
      "• Basics of Human Physiology",
      "• Basics of Food & Nutritional Biochemistry",
      "• Basics of Environmental Science",
      "• Basics of Computer Application",
      "• Basics of Leadership & Team Management",
      "",
      "For DWO candidates:- Total 100 Marks",
      "Part 1 – General Knowledge (20 Marks)",
      "• Indian History",
      "• Indian Economy",
      "• Indian Geography",
      "• Indian Politics",
      "",
      "Part 2 – Special Paper (80 Marks)",
      "• Basics of Human Anatomy",
      "• Basics of Human Physiology",
      "• Basics of Food & Nutritional Biochemistry",
      "• Basics of Environmental Science",
      "• Basics of Computer Application",
      "• Basics of Leadership & Team Management",
    ],
  },
];

export const ExamPatternNew = () => {
  return [
    {
      title:
        "RWO Exam will be in TWO SECTIONS (no break/gap will be there in between the sections)",
      bold: true,
    },
    {
      title: "Section 1 :- Duration 30 minutes",
      semibold: true,
    },
    {
      title:
        "Only MCQ from both the parts of the Syllabus (10 Questions from Part - 1, 30 Questions from Part - 2)",
    },
    {
      title: "Section 2 :- Duration 60 minutes",
      semibold: true,
    },
    {
      title:
        "Short Questions from both the parts of the Syllabus (5 Questions from Part - 1, 10 Questions from Part - 2)",
    },
    {
      title: "Long Questions only from Part - 2 of the Syllabus (6 Questions)",
    },
    {
      title:
        "DWO Exam will be in ONE SECTION only with 100 MCQs, 20 MCQs from Part 1 and 80 MCQs from Part 2 Books",
      bold: true,
    },
    {
      title: "MODE OF EXAM IS ONLINE",
      bold: true,
    },
    {
      title: "Rules of Exam :-",
      bold: true,
    },
    {
      list: [
        "Appearing the exam in MOBILE or TABLET is not allowed. (Exam is incompatible to Mobile or Tablet)",
        "No top-up of time allotted for 2nd Sections of exam if you finish the 1st Section earlier.",
        "Minimizing the main Exam Window will not be allowed during examination.",
        "No video and audio OFF is allowed during Exam.",
        "No other person will be allowed in your examination room.",
        "After submitting the paper, take permission from the Proctor to leave the Zoom.",
        "If a candidate has submitted the paper without connecting in Zoom will not be accepted/evaluated.",
        "Blur background or using a background wall-paper is not allowed in Zoom.",
        "You have to show us your Room, Table and Mobile (where you have kept it) by moving your Laptop or Webcam.",
        "Your video will be recorded. If any suspicious activities are observed during the exam, it may result in disqualification from the final interview round due to a lack of honesty.",
        "A few other rules are mentioned or will be mentioned on your ADMIT CARD that must be followed by each and every candidate.",
      ],
    },
  ];
};
